var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    stroke: "#D9DAF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0353 25.7398C14.6233 27.1462 16.7119 28 19 28C21.2881 28 23.3767 27.1462 24.9647 25.7398C24.672 24.6873 22.5694 24 19 24C15.4306 24 13.328 24.6873 13.0353 25.7398ZM11.6005 24.1246C12.726 22.6381 15.3706 22 19 22C22.6294 22 25.274 22.6381 26.3995 24.1246C27.4086 22.6703 28 20.9042 28 19C28 14.0294 23.9706 10 19 10C14.0294 10 10 14.0294 10 19C10 20.9042 10.5914 22.6703 11.6005 24.1246ZM19 30C12.9249 30 8 25.0751 8 19C8 12.9249 12.9249 8 19 8C25.0751 8 30 12.9249 30 19C30 25.0751 25.0751 30 19 30ZM15 17C15 14.7558 16.5791 13 19 13C21.4142 13 23 14.9216 23 17.2C23 20.4796 21.2181 22 19 22C16.7609 22 15 20.4274 15 17ZM17 17C17 19.2693 17.8182 20 19 20C20.1777 20 21 19.2984 21 17.2C21 15.9504 20.2157 15 19 15C17.7337 15 17 15.8158 17 17Z",
    fill: "#292A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0353 25.7398C14.6233 27.1462 16.7119 28 19 28C21.2881 28 23.3767 27.1462 24.9647 25.7398C24.672 24.6873 22.5694 24 19 24C15.4306 24 13.328 24.6873 13.0353 25.7398ZM11.6005 24.1246C12.726 22.6381 15.3706 22 19 22C22.6294 22 25.274 22.6381 26.3995 24.1246C27.4086 22.6703 28 20.9042 28 19C28 14.0294 23.9706 10 19 10C14.0294 10 10 14.0294 10 19C10 20.9042 10.5914 22.6703 11.6005 24.1246ZM19 30C12.9249 30 8 25.0751 8 19C8 12.9249 12.9249 8 19 8C25.0751 8 30 12.9249 30 19C30 25.0751 25.0751 30 19 30ZM15 17C15 14.7558 16.5791 13 19 13C21.4142 13 23 14.9216 23 17.2C23 20.4796 21.2181 22 19 22C16.7609 22 15 20.4274 15 17ZM17 17C17 19.2693 17.8182 20 19 20C20.1777 20 21 19.2984 21 17.2C21 15.9504 20.2157 15 19 15C17.7337 15 17 15.8158 17 17Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e31e28e4625eee89083b7ca1275b1001.svg";
export { ForwardRef as ReactComponent };